import ContactUsComponent from './ContactUsComponent';

const ContactUs = ({ slice }) => <ContactUsComponent slice={slice} />;

export default ContactUs;
